import CameraIcon from "@redotech/redo-icons/camera-03_filled.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { evidenceFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  EvidenceState,
  isEvidenceStepValid,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const EVIDENCE = (
  Details: React.ComponentType<StepTypeDetailsProps<EvidenceState>>,
): StepType<EvidenceState, Step.Evidence> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) => state.prompt,
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: { prompt: "", scope: "return_item" },
  fromModel: (model, id) => evidenceFromModel(model, id),
  Icon: CameraIcon,
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: STEP_TYPE_NAMES[Step.EVIDENCE],
  toModel(state, id) {
    return {
      type: Step.EVIDENCE,
      customTitle: state.customTitle,
      prompt: state.prompt,
      notesLabel: state.notesLabel,
      notesPlaceholder: state.notesPlaceholder,
      imageUrl: state.imageUrl,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(`Invalid handle index ${handleIndex} for evidence step`);
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isEvidenceStepValid(state).valid,
});
